module.exports = __webpack_public_path__ + "static/img/ua.4437573c.svg";